import { render, staticRenderFns } from "./RegManager.vue?vue&type=template&id=08277396&scoped=true"
import script from "./RegManager.vue?vue&type=script&lang=js"
export * from "./RegManager.vue?vue&type=script&lang=js"
import style0 from "./RegManager.vue?vue&type=style&index=0&id=08277396&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08277396",
  null
  
)

export default component.exports